import {Breadcrumbs} from "../../components/breadcrumbs/breadcrumbs";
import {ClientForm} from "../../components/form/clientForm";
import {useGlobalContext} from "../../hooks/globalContext";
import {useEffect} from "react";
import {useParams} from "react-router-dom";

export function EditClient() {
    const {i18n} = useGlobalContext()
    useEffect(() => {
        document.title = i18n.editing_organization()
    }, [i18n])
    let {id} = useParams()

    let infos = [
        {link: "/staff/clients/", title: "Клиенты", index: "breadcrumbs-id"},
        {link: `/staff/clients/edit/${id}`, title: "Редактировать клиента", index: "breadcrumbs-id"}
    ]

    return (
        <section className="app__main">
            <main role="main" className="app__content">

                <Breadcrumbs infos={infos}/>


                <div className="app__header">
                    <div className="app__header-left">
                        <h1 className="app__header-title">{i18n.edit_client()}</h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-8 col-xl-5">
                        <div className="default-card">

                            <ClientForm/>

                        </div>
                    </div>
                </div>
            </main>
        </section>
    )
}
